"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var WebMafLifecycle = (function (_super) {
    __extends(WebMafLifecycle, _super);
    function WebMafLifecycle(webMafBridge) {
        var _this = _super.call(this) || this;
        _this.webMafBridge = webMafBridge;
        _this.suspendObservable = new client_lib_js_player_addons_common_player_1.Observable();
        _this.resumeObservable = new client_lib_js_player_addons_common_player_1.Observable();
        _this.webMafBridge.listenToEvent('applicationStatusChange', function (data) {
            if (data.applicationStatus === 'foreground') {
                _this.resumeObservable.notifyObservers(undefined);
            }
            else {
                _this.suspendObservable.notifyObservers(undefined);
            }
        });
        return _this;
    }
    WebMafLifecycle.prototype.onSuspending = function (handler) {
        this.suspendObservable.registerObserver(handler, this);
        return true;
    };
    WebMafLifecycle.prototype.onResuming = function (handler) {
        this.resumeObservable.registerObserver(handler, this);
        return true;
    };
    return WebMafLifecycle;
}(client_lib_js_player_addons_common_player_1.Lifecycle));
exports.WebMafLifecycle = WebMafLifecycle;
